import { Box, IconButton } from "@mui/material"; // Add Theme import
import EyeLineIcon from "remixicon-react/EyeLineIcon";
import { useQuery } from "react-query";
import { createUseStyles } from "react-jss";
import Text from "$components/Text";
import useOrder from "$hooks/useOrder";
import { DockyardServices, ProjectServices } from "$services";
import { Loader } from "$components/Layout/Loader";
import { OrderFormPopin } from "./OrderFormPopin";
import { usePopin } from "$components/Popin/usePopin";
import { CacheInvalidationAction } from "$utils/cache";
import { theme } from "$utils/theme/bataillog";

type Props = {
  order: any;
};

function OrderLabel({ order }: Props) {
  const { dockyard, project, reference, suborders } = order;
  const classes = useStyles();
  const { getSplitSuborderTypeInfo, getSubOrderType } = useOrder();
  const { Popin, PopinProps, togglePopin } = usePopin();

  // get one project
  const { data: projectFilter, isLoading: isProjectLoading } = useQuery(
    [CacheInvalidationAction.GET_PROJECT_BY_ID, project],
    () => ProjectServices.getProjectById(project),
    {
      enabled: !!project,
      staleTime: 1000 * 60,
    }
  );

  // get one dockyard
  const { data: dockyardFilter, isLoading: dockyardLoading } = useQuery(
    [CacheInvalidationAction.GET_DOCKYARD_BY_ID, dockyard],
    () => DockyardServices.getDockyardById(dockyard),
    {
      enabled: !!dockyard,
      staleTime: 1000 * 60,
    }
  );

  if (dockyardLoading || isProjectLoading) {
    return <Loader />;
  }

  const isOrder = !!suborders;
  const { code, label, name } = getSplitSuborderTypeInfo(
    order.type,
    projectFilter,
    dockyardFilter
  );

  return (
    <>
      <Box className={classes.wrapper}>
        {isOrder ? (
          <Text type="important">COMMANDE N°{reference}</Text>
        ) : (
          <Text type="text">
            Sous-commande n°
            <Text type="important" style={{ fontSize: "inherit" }}>
              {reference}
            </Text>
            {name && <Text className={classes.typeBlock}>{name}</Text>}
            {(code || label) && (
              <Text
                type="secondary"
                className={classes.typeBlock}
                style={{ display: "inline" }}
              >
                {code} ({label || getSubOrderType(order.type)})
              </Text>
            )}
          </Text>
        )}
        {isOrder && (
          <IconButton size="small" onClick={togglePopin}>
            <EyeLineIcon />
          </IconButton>
        )}
      </Box>
      <Popin {...PopinProps} minWidth="70%">
        <OrderFormPopin
          order={order}
          togglePopin={togglePopin}
          isOrder={isOrder}
        />
      </Popin>
    </>
  );
}

export default OrderLabel;

// Fix the theme typing issue by explicitly typing theme as Theme
const useStyles = createUseStyles(() => ({
  typeBlock: {
    marginLeft: "4px",
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));
